import { useGetDailyFormInspectionQuestionsLazyQuery } from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormInspectionQuestions() {
  const [query, { data: graphqlData, loading, error }] =
    useGetDailyFormInspectionQuestionsLazyQuery();

  const getDailyFormInspectionQuestions = useCallback(() => {
    query();
  }, [query]);

  const data = useMemo(() => {
    return graphqlData?.getDailyFormInspectionQuestions || [];
  }, [graphqlData]);

  return [getDailyFormInspectionQuestions, { data, loading, error }] as const;
}
